import { useQuery } from '@tanstack/react-query';
import { getDropdownItems } from '../services/fn-api/Common';
import { DROPDOWN_ITEMS_KEY } from 'src/utils/constants/queryKeys';

export const useGetDropdownItems = (type: string) => {
  return useQuery({
    queryKey: [DROPDOWN_ITEMS_KEY, type],
    queryFn: () => getDropdownItems(type),
    enabled: !!type,
  });
};
